var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRuler = function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M13.708 3.585L10.415.293A1 1 0 009 .293L.293 9a1 1 0 000 1.414l3.293 3.293a1 1 0 001.414 0L13.708 5a1 1 0 000-1.415zM4.293 13L1 9.707l2-2 1.647 1.647a.5.5 0 00.707-.708L3.707 7 5 5.707l1.647 1.647a.5.5 0 10.707-.708L5.707 5 7 3.707l1.647 1.647a.5.5 0 00.707-.708L7.707 3l2-2L13 4.293 4.293 13z"
  })));
};
export default SvgRuler;